import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {isEmpty, isUndefined} from 'lodash';
import {Country} from '../country.i';

@Injectable()
export class CountriesService {

    constructor(private http: Http) {
    }

    private allowedCountries: Array<any>;
    private europeanCountries: Array<any>;
    private availableCountries: Array<any>;
    private countries$: Observable<Country[]>;
    private sepaCountries: Array<any>;

    getCountries(clearCache = false): Observable<Country[]> {
        if (!this.countries$ || clearCache) {
            this.countries$ = this.getCountriesWithFilter(false)
            .map(countries => countries)
            .publishReplay(1)
            .refCount();
        }
        return this.countries$;
    }

    getAllowedPaymentsCountries(): Observable<Array<any>> {
        if (isEmpty(this.allowedCountries)) {
            return this.getCountriesWithFilter(true)
            .map(countries => {
                this.allowedCountries = countries;
                return this.allowedCountries;
            });
        } else {
            return Observable.of(this.allowedCountries);
        }
    }

    getEuropeanCountries(): Observable<Array<any>> {
        if (isEmpty(this.europeanCountries)) {
            return this.getEuropeCountries()
            .map(countries => {
                this.europeanCountries = countries;
                return this.europeanCountries;
            });
        } else {
            return Observable.of(this.europeanCountries);
        }
    }

    getAvailableCountries(): Observable<Array<any>> {
        if (isEmpty(this.availableCountries)) {
            return this.getAllAvailableCountries()
                .map(countries => {
                    this.availableCountries = countries;
                    return this.availableCountries;
                });
        } else {
            return Observable.of(this.availableCountries);
        }
    }

    getAllowedSepaPaymentsCountries(): Observable<Array<any>> {
        if (isEmpty(this.sepaCountries)) {
            return this.getSepaCountries()
            .map(countries => {
                this.sepaCountries = countries;
                return this.sepaCountries;
            });
        } else {
            return Observable.of(this.sepaCountries);
        }
    }


    private getCountriesWithFilter(allow: boolean): Observable<any[]> {
        return this.http.get('/api/client/dictionary/countries', {search: this._buildSearchParam(allow)})
        .map(response => response.json())
        .map(response => response.countries);
    }

    getCountryById(id: number): Observable<Country> {
        return this.http.get('/api/client/dictionary/country', {search: this._buildSearchParamId(id)})
        .map(response => response.json());
    }

    private getEuropeCountries(): Observable<any[]> {
        return this.http.get('/api/client/dictionary/countries/europe')
        .map(response => response.json())
        .map(response => response.countries);
    }

    private getAllAvailableCountries(): Observable<any[]> {
        return this.http.get('/api/client/dictionary/countries/available')
            .map(response => response.json())
            .map(response => response.countries);
    }

    private getSepaCountries(): Observable<any[]> {
        return this.http.get('/api/client/dictionary/countries/sepa')
        .map(response => response.json())
        .map(response => response.countries);
    }


    getAllCountries(): Observable<Country[]> {
        return this.http.get('/api/client/dictionary/countries/all')
        .map(response => response.json())
        .map(response => response.countries);

    }

    private _buildSearchParam(allow: boolean): URLSearchParams {
        let search: URLSearchParams = new URLSearchParams();
        search.set('allow_pay', String(allow));
        return search;
    }

    private _buildSearchParamId(id: number): URLSearchParams {
        let search: URLSearchParams = new URLSearchParams();
        search.set('id', String(id));
        return search;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/countries.service.ts